/**
 * DAVMAN AI INTEGRATION
 * Este archivo es parte de la integración personalizada de IA para Davman Persa.
 * NO es parte del código original de Chatwoot.
 *
 * Configuración del módulo Davman AI
 */

/**
 * Configura el módulo Davman AI
 *
 * Esta función debe ser llamada al inicio de la aplicación para configurar
 * la URL del microservicio.
 *
 * @param {object} config - Configuración
 * @param {string} config.url - URL base del microservicio Davman AI
 */
export function initializeDavmanAI(config = {}) {
  window.davmanAiConfig = {
    url: config.url || getDefaultUrl(),
    enabled: config.enabled !== false,
  };
}

/**
 * Obtiene la URL por defecto basada en el entorno
 */
function getDefaultUrl() {
  // En desarrollo, usar localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }

  // En producción, usar el mismo host pero puerto 3001
  // O puedes configurar una URL específica aquí
  return `${window.location.protocol}//${window.location.hostname}:3001`;
}

/**
 * Verifica si Davman AI está habilitado
 */
export function isDavmanAIEnabled() {
  return window.davmanAiConfig?.enabled !== false;
}

/**
 * Obtiene la configuración actual
 */
export function getDavmanAIConfig() {
  return window.davmanAiConfig || { url: getDefaultUrl(), enabled: true };
}

// Auto-inicializar con valores por defecto si no se ha configurado
if (typeof window !== 'undefined' && !window.davmanAiConfig) {
  initializeDavmanAI();
}
